export default "__VITE_ASSET__Ct5btX7p__"